import { supabase } from '../../db';
import { Conversation } from '../types';

export const conversationService = {
  getConversations: async (userId: string): Promise<Conversation[]> => {
    try {
      const { data, error } = await supabase
        .rpc('get_user_conversations', { 
          user_id_param: userId 
        });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching conversations:', error);
      throw error;
    }
  },

  getOrCreateConversation: async (userId: string, recipientId: string): Promise<string> => {
    try {
      const { data, error } = await supabase
        .rpc('get_or_create_conversation', {
          user_id_param: userId,
          recipient_id_param: recipientId
        });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting/creating conversation:', error);
      throw error;
    }
  },

  subscribeToConversations: (userId: string, onUpdate: () => void) => {
    const channel = supabase.channel(`user_conversations:${userId}`);
    
    channel
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations',
          filter: `initiator_id=eq.${userId}`,
        },
        onUpdate
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations',
          filter: `recipient_id=eq.${userId}`,
        },
        onUpdate
      )
      .subscribe();

    return channel;
  }
};